import React from "react";

export default function SupportPage() {
 const submitTicket = () => {
   alert("If you have a problem, fix it yourself.");
 };

 // Inline CSS as React styles:
 const rootStyle = {
   fontFamily: "Arial, sans-serif",
   backgroundColor: "#f3f3f3",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
   justifyContent: "center",
   height: "100vh"
 };
 const buttonStyle = {
   backgroundColor: "#e63946",
   color: "white",
   border: "none",
   padding: "12px 24px",
   fontSize: "16px",
   borderRadius: "8px",
   cursor: "pointer",
   width: "500px",
   transition: "background-color 0.3s"
 };
 const buttonHoverStyle = {
   backgroundColor: "#d62828"
 };

 // For a simple hover effect in React, you can use state:
 const [hover, setHover] = React.useState(false);

 return (
   <div style={rootStyle}>
     <h1>Welcome to Kebatic Support</h1>
     <button
       style={hover ? { ...buttonStyle, ...buttonHoverStyle } : buttonStyle}
       onMouseEnter={() => setHover(true)}
       onMouseLeave={() => setHover(false)}
       onClick={submitTicket}
     >
       Submit a Ticket
     </button>
   </div>
 );
}